import { BlogPost } from '../data/blogPosts';

const aliases: Record<string, string> = {
  htb: 'hackthebox', 'web attacks': 'web attack',
  tunnelin: 'tunneling', forwading: 'forwarding',
};

export function normalizeTag(tag: string): string {
  const normalized = tag.trim().toLowerCase();
  return aliases[normalized] || normalized;
}

export const categories = [
  { id: 'all', label: 'All' },
  { id: 'ctf', label: 'CTF' },
  { id: 'web', label: 'Web' },
  { id: 'mobile', label: 'Mobile' },
  { id: 'notes', label: 'Notes' },
];

export function matchesCategory(post: BlogPost, category: string): boolean {
  const tags = post.tags.map(normalizeTag);
  const isCTF = tags.includes('hackthebox') || tags.includes('ctf') || tags.includes('writeup');
  const isMobile = /android|ios|mobile|frida|ssl pinning|burp.*certificate/i.test([post.title, ...tags].join(' '));
  if (category === 'ctf') return isCTF;
  if (category === 'mobile') return isMobile;
  if (category === 'web') return tags.some(tag => /web|sql|xss|idor|lfi|file upload|authentication|ffuf|burp/.test(tag));
  if (category === 'notes') return !isCTF && !isMobile;
  return true;
}

export function filterPosts(posts: BlogPost[], query: string, category: string, topics: string[]): BlogPost[] {
  const term = query.trim().toLowerCase();
  const selectedTopics = topics.map(normalizeTag);
  return posts.filter(post => matchesCategory(post, category)
    && (!selectedTopics.length || post.tags.some(tag => selectedTopics.includes(normalizeTag(tag))))
    && (!term || [post.title, post.description || '', ...post.tags, ...post.tags.map(normalizeTag)].join(' ').toLowerCase().includes(term)));
}

export function displayTag(tag: string): string {
  const normalized = normalizeTag(tag);
  const names: Record<string, string> = { hackthebox: 'HackTheBox', cve: 'CVE', idor: 'IDOR', lfi: 'LFI', xss: 'XSS', 'sql injection': 'SQL injection', 'active directory': 'Active Directory', 'burp suite': 'Burp Suite', 'web pentest': 'Web pentest', api: 'API' };
  return names[normalized] || normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function readMinutes(post: BlogPost): number {
  return Math.max(1, Math.ceil(post.content.trim().split(/\s+/).length / 200));
}

export function formatPostDate(date: string): string {
  const value = new Date(date);
  return Number.isNaN(value.getTime()) ? date : value.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
}
